import { defineMessages } from 'react-intl';

export default defineMessages({
  filterModalTitle: {
    id: 'features.walletDossierFilters.filterModalTitle',
    defaultMessage: 'Seleziona il dossier',
    description: 'Title of the wallet filter modal',
  },

  filterRecalculateButton: {
    id: 'features.walletDossierFilters.filterRecalculateButton',
    defaultMessage: 'Applica',
    description: 'Label of the recalculate button in the wallet filter modal',
  },
  openTooltip: {
    id: 'features.walletDossierFilters.openTooltip',
    defaultMessage: 'Aperto',
    description: 'Label for green icon representing the still open dossier',
  },
  closeTooltip: {
    id: 'features.walletDossierFilters.closeTooltip',
    defaultMessage: 'Chiuso',
    description: 'Label for red icon representing the dossier already closed',
  },
});
